// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2TAph","name":"Header_name__hFBRO","birthday":"Header_birthday__1qj4E","skeleton":"Header_skeleton__27hCt"};